<template>
	<div class="inline-filter-selector" 
	:class="dynamicClasses" 
	v-bind="config.attrs" v-click-outside="autoClose">
		<config-style-injector :root-selector="`.inline-filter-selector`" :config="config" />
		<div class="filter-list" :class="{ open: showList }">
			  <div class="filter-header">
		 <button class="clear-all-btn" ref="firstFocusable" @click="clearFilters">
	 <span class="label">{{ content.clearAll }}</span>
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
				stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
				class="icon feather feather-refresh-ccw">
			<path d="M1 4v6h6M23 20v-6h-6"/>
			<path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/>
			</svg>
		</button>
		</div>
			<div class="inline-filter-content">
				<component
				v-for="filter in inlineFilters"
				:key="filter.name"
				:is="filter.component"
				:feature-config="filter.config"
				:items="filter.config.items"
				/>
			
			</div>
		
			<div v-if="showFooterSearchResultButton" class="filter-footer">
			<button
			class="filter-footer-btn"
			v-bind="footerSearchResultButtonAttrs"
			@click="applyFilters"
			>
			<span>{{ footerSearchResultButtonLabel }}</span>

			<config-style-injector
				:config="SearchResultButtonConfig"
				:root-selector="`.inline-filter-selector .filter-footer-btn`"
			/>
			</button>
		</div>
		</div>
			   <component :is="filterSelectorTemplate" />
		   <!--  FOOTER SearchResult BUTTON -->
	
	</div>
	
	
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";
import FlyerThumbList from "@/features/flyer-selector/FlyerThumbList.vue";
import Lytics from "@/classes/Lytics";
import { mapGetters, mapState,mapActions } from "vuex";
import { appDict } from "@/features/FeatureHelper";

import AppConfig from "@/classes/AppConfig";
import InlineFilterSelectorCTC from "./InlineFilterSelectorCTC.vue";
import { filterDict } from "@/features/FeatureHelper";
export default {
	name: "InlineFilterSelector",
	components: {FlyerThumbList, ConfigStyleInjector},
	mixins:[featureMixin],
	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			featurePath: 'filterSortSelector',
			impressionFired: false,
			isHidden: false,
			lastScrollPosition: 0,
			hasResults: false,
		}
	},
	mounted() {
		this._config.isVisible = this.isFilterOpen;
		this.hasResults = !!(this.sortedHits?.length > 0);
		if (this.autofocus) {
			// delay so the "drawer opened" live-region announcement is heard before focus moves and announces the button
			this.$nextTick(() => {
				this._focusTimeout = setTimeout(() => this.$refs.firstFocusable?.focus(), 750);
			});
		}
    },
	beforeDestroy() {
		clearTimeout(this._focusTimeout);
	},
	created() {
		
  // keep position logic intact
  if (
    this.config.position === 'top' &&
    this.config._flyerOrientation['+vertical']?.defaultVisibility !== undefined
  ) {
    this._config.isVisible =
      this.config._flyerOrientation['+vertical'].defaultVisibility;
  }

 
  this._config.__hasLoaded = true;
},

	computed:{
		...mapGetters('landingPage', ['sortedFlyers', 'currentFlyer']),
		...mapGetters('raddar', ['isRaddar']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapState('scale', ['scrollY']),
		...mapState('drawer', ['drawerItems']),
		...mapGetters('inlineDrawers', ['isFilterOpen']),
		...mapGetters('config', ['features']),
		...mapGetters('filters', ["hasFilters", "filtersByType", "filtersByName",'searchQuery']),
			...mapGetters('search', ['showSearchResults','sortedHits','ratedHits','availableRatingThresholds']),
			...mapState('search', { searchLoading: 'loading' }),
		...mapGetters(['isCTC', 'content']),
		...mapGetters('ctOffersUser', ['canViewOneToOneOffers','hasOneToOneOffers']),
		...mapGetters('ctUser',['canViewPersonalizedBanner','offerViewMode']),

		templates() {
			return {
				ctc: InlineFilterSelectorCTC,
			};
		},
		SearchResultButtonConfig() {
		return this.features?.filterSortSelector?.showSearchResultButton;
		},

		showFooterSearchResultButton() {
		return !!(
			(this.isMobile || this.isTablet) &&
			this.SearchResultButtonConfig?.enabled
		);
		},
		footerSearchResultButtonLabel() {
		return this.SearchResultButtonConfig?.label || '';
		},

		footerSearchResultButtonAttrs() {
		return this.SearchResultButtonConfig?.attrs || {};
		},
	hasNonSortFilters() {

		const hasNonSortKeys = Object.keys(this.searchQuery).filter(k => k !== 'Sort').length > 0;
		if (this.isMobile || this.isTablet) {
			return hasNonSortKeys && !!(this.sortedHits?.length > 0);
		}
		return this.hasResults && hasNonSortKeys;
	},
	hasNonStarRateFilters() {

		const hasNonStarRateKeys = Object.keys(this.searchQuery).filter(k => k !== 'rating').length > 0;
		if (this.isMobile || this.isTablet) {
			return hasNonStarRateKeys && !!(this.sortedHits?.length > 0);
		}
		return this.hasResults && hasNonStarRateKeys;
	},
	isOneToOneOfferSelected() {
		const offer = this.searchQuery.offer;
		if (!offer) return false;
		if (Array.isArray(offer)) return offer.length > 0;
		return !!offer;
	},
	 inlineFilters() {
			const result = [];
			const filterNames = this.features.filterPanel.filters;
			const dict = filterDict;
			for (let i = 0; i < filterNames.length; i++) {
			const name = filterNames[i];
			// ONLY category + discount + Brand+ Pricing+ sorting here
			if (!['Sort', 'category', 'saving', 'brand', 'pricing',"loyalty","rating","offer"].includes(name)) continue;
			if (name === 'Sort' && (!this.hasNonSortFilters || this.isOneToOneOfferSelected)) continue;
			if(name==='rating'&& (!this.hasNonStarRateFilters || this.isOneToOneOfferSelected)) continue;
			if(name=='offer' && (!this.canViewOneToOneOffers || this.canViewPersonalizedBanner==false || this.hasOneToOneOffers==false || this.offerViewMode=='preview')) continue
			const f = this.filtersByName[name];
			if (f && dict[f.type]) {
				let config = f;
				if (name === 'rating' && f.items) {
					const available = this.availableRatingThresholds;
					config = { ...f, items: f.items.filter(item => available.includes(item.value)) };
				}
				result.push({
				name,
				component: dict[f.type],
				config
				});
			}
			}
			return result;
  },
  
	dynamicClasses() {
		return [
			this.config.position,
			
			this.isVertical ? 'vertical': '',
			this.isMobile ? 'mobile': '',
			this.isTablet ? 'tablet' : '',
			this.isConfigurable ? 'configurable': ''
		];
	},
	filterSelectorTemplate() {
      const t = this.templates;
	  return t[this.config.template] || null;
    },
	isVertical() {
			return this.flyerOrientation === 'vertical';
		},
		isConfigurable() {
			return  this.flyerOrientation === 'vertical' && this.displayMode === 'desktop' && this.flyerDrawer;
		},
		flyerDrawer() {
            return this.features.filterSortSelector._flyerOrientation['+vertical']?.['_display']?.['+desktop']?.position === 'left';
		},
		
		isMobile() {
			return this.displayMode === 'mobile';
		},
		isTablet() {
		return this.displayMode === 'tablet';
		},
		showList(){
			return this.isFilterOpen;
		},
	},
	methods:{

		...mapActions("search", ["queryAlgolia","setShowSearchResults","filterProducts"]),
		...mapActions('inlineDrawers', ['closeAll','openFlyer','setFilterSortWindowOpen']),
		...mapActions('filters', ['clearFilters']),
		...mapActions(['setTiledView']),

		autoClose(){
			if(this.config.autoClose)this._config.isVisible = false;
		},
		
		async applyFilters() {

			this.setFilterSortWindowOpen(false);
			// this.setShowSearchResults(true);
			if (Object.keys(this.searchQuery).length && this.isCTC) {
				await this.setTiledView(true);
			}

    		if (!(this.isOneToOneOfferSelected && (this.isMobile || this.isTablet))) {
    			await this.filterProducts(this.searchQuery);
    		}
			

		//  remove filter drawer
		await this.$store.dispatch(
		"drawer/removeFromDrawer",
		{ id: "filterSortSelector", drawer: "top" },
		{ root: true }
		);

		
    	// open flyer drawer
		await this.$store.dispatch(
		"drawer/openSingleInDrawer",
		{
			id: "flyerSelector",
			component: appDict.inlineFlyerSelector,
			drawer: "top",
			attrs: {}
		},
		{ root: true }
		);

		await this.openFlyer();
		Lytics.TriggerDrawerToggle(true);
  		},

		triggerFlyerImpressions() {
			if (!this.showList) return;
			if (this.impressionFired) return;

			// filter out current flyer impression so it can be handled by flyer load to account for drawer not opened
			const sortedFlyersMinusCurrentFlyer = this.sortedFlyers.filter(flyer => flyer.title !== this.currentFlyer.title);

			sortedFlyersMinusCurrentFlyer.forEach(flyer => {
				Lytics.TriggerFlyerImpression({ 
					flyer,
					client: AppConfig.AppConf?.retailer,
					banner: AppConfig.AppConf?.title,
					store_id: this.$route.query.storeId,
					platform: this.isRaddar ? "raddar" : "client_site"
				});
			});

			this.impressionFired = true;
		}
	},
	watch: {
		showList: {
			handler() {
			setTimeout(() => {
				this.triggerFlyerImpressions();
			}, 500);
			},
			immediate: true
		},

  scrollY(newValue) {
    if (
      newValue > 30 &&
      this._config.shouldHide &&
      newValue > this.lastScrollPosition &&
      !this.isConfigurable
    ) {
      this._config.isVisible = false;
    } else {
      this._config.shoudHide = false;
    }
    this.lastScrollPosition = newValue;
  },
  	

//   isFilterOpen(val) {
//     if (val) {
//       this._config.isVisible = false;
//     } else {
//       this._config.isVisible = true;
//     }
//   }
  isFilterOpen(val) {
    this._config.isVisible = val;
  },
  searchQuery: {
    deep: true,
    handler(newQuery, oldQuery) {
      const nonSortKeys = q => Object.keys(q || {}).filter(k => k !== 'Sort');
      if (nonSortKeys(oldQuery).length === 0 && nonSortKeys(newQuery).length > 0) {
        this.hasResults = false;
      }
    }
  },
 searchLoading(isLoading) {
  if (!isLoading) {
    this.hasResults = !!(
      this.sortedHits?.length > 0 ||
      this.ratedHits?.length > 0 ||
      this.availableRatingThresholds?.length > 0
    );
  }
},
}

}
</script>

<style lang="scss">

.inline-filter-selector.left {
  .filter-list {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: #fff;
    overflow-y: auto;
	max-height: calc(100vh - 60px);
	padding: 12px 16px;
	//padding-right: 11px;
	box-sizing: border-box;
	 width: 100%;
  }
}
/* Inline Filter – accordion row style (Category / Discount) */
.inline-filter-selector.left {

  .inline-filter-content {
   width: 100%;
	height: auto;
    flex: 0 0 auto;
    padding-bottom: 70px;
	
  }

  .accordion-section {
    width: 100%;
  }

  .accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 14px 16px;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
  }

  .accordion-body {
    padding: 8px 16px 16px;
    background: #fff;
  }

  .icon {
    font-size: 18px;
    line-height: 1;
  }
}
.inline-filter-selector .collapse-icon,
.inline-filter-selector .icon {
		color: #000;
		flex-shrink: 0;
}
.inline-filter-selector {
		 --drawer-open-width: 15em;
		height: 100%;
		display: flex;
		// color: #000;
		
		.toggle-tab {
			position: relative;
			background-color: #333333;
			display: flex;
			writing-mode: vertical-rl;
			//column-gap: 0.5em;
			cursor: pointer;
			align-items: center;
			.caption {
				rotate: 180deg;
				font-size: 0.8em;
			}
			.rotate-chevron {
				width: 0.6em;
			}
			
		}

		&.left{
			.filter-list{
				width: 0px;
				&.open{
					width: var(--drawer-open-width);
				}
			}
		}
		&.top{
			flex-direction: column;
			.filter-list{
				height: 0;
				&.open{
					height: 12em;
				}
			}
			.flyer-thumb-list {
				display: flex;
				//column-gap: 0.6em;
				padding: 0.5em;
				align-items: center;
				>* {
					margin-right: 1em !important;
				}
				.flyer-thumb-button {
					width: 12em;
					flex: none;
					margin: 0;
					height: fit-content;
				}
			}
		}
		.flyer-thumb-button {
			margin: 1em;
		}
}
/* Footer container */
.inline-filter-selector .filter-footer {
  width: 100%;
  padding: 16px;
  background: #fff;
  display: flex;
  justify-content: center;
}

/* Footer button base */
.inline-filter-selector .filter-footer-btn {
  width: 100%;
  max-width: 320px;
  height: 48px;

  border: none;
  border-radius: 6px;

  font-size: 16px;
  font-weight: 600;

  cursor: pointer;
}
.inline-filter-selector.mobile .accordion-section.open .accordion-header
 {
  padding-bottom: 24px;
}
.inline-filter-selector.tablet .accordion-section.open .accordion-header
{
	padding-bottom: 54px;
}
.inline-filter-selector.mobile.top .filter-list,
.inline-filter-selector.tablet.top .filter-list
 {
  height: auto !important;
  max-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Only the filter options scroll; header and footer stay pinned in place */
.inline-filter-selector.mobile.top .filter-list .inline-filter-content,
.inline-filter-selector.tablet.top .filter-list .inline-filter-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.inline-filter-selector.mobile.top .filter-list .filter-header,
.inline-filter-selector.tablet.top .filter-list .filter-header {
  flex: 0 0 auto;
}

.inline-filter-selector.mobile.top .filter-list .filter-footer,
.inline-filter-selector.tablet.top .filter-list .filter-footer {
  flex: 0 0 auto;
  border-top: 1px solid #eee;
}
.inline-filter-selector .filter-header {
  width: 100%;
 
  background: #fff;
   display: flex;
}

.inline-filter-selector .clear-all-btn {
  display: inline-flex;
  align-items: left;
  gap: 10px;
    margin-bottom: 20px;
  width: 100%;
  min-height: 32px;
  border-radius: 10px;
  background-color: #f2f2f2; 
  border: none;
	
  font-size: 13px;
  font-weight: 500;
  color: #545454;
  cursor: pointer;
}

.inline-filter-selector .clear-all-btn .icon {
  width: 14px;
  height: 14px;
}

.inline-filter-selector .clear-all-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

</style>
